import { MinimumStationsGroup } from '@app/core/types/stations';
import {
  stationsStationsGroupsListForStationQueryKey,
  useStationsStationsGroupsListForStation,
} from '@mi-front/api-v2';

/**
 * Loads station groups that include the given station via api-v2 generated query.
 */
export function useStationGroups(stationIdOrSlug: string, enabled = true) {
  return useStationsStationsGroupsListForStation<MinimumStationsGroup[]>(stationIdOrSlug, {
    query: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      enabled,
      select: (data) => data as unknown as MinimumStationsGroup[],
    },
  });
}

useStationGroups.queryKey = stationsStationsGroupsListForStationQueryKey;
